import styled from 'styled-components';

const FormWrapper = styled.div`
	background: ${({ theme }) => theme.backgroundFormWrapper};
	width: 490px;
	margin: auto;

	.titular-dependente {
		display: flex;
		flex-direction: column;
		background-color: hsl(0, 0%, 96%);
		border-radius: 10px;
		border: 2px solid ${({ theme }) => theme.borderTitularDepende};
		max-width: 490px;
		margin: auto;
		height: auto;
		padding: 15px 15px 0 15px;
	}

	@media (max-width: 992px) {
		width: 100%;
		.titular-dependente {
			max-width: 100%;
		}
	}
`;

export default FormWrapper;
